var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sigma-report-container"},[_c('iframe',{ref:"iframe",attrs:{"title":_vm.report.title || 'Dashboard',"src":_vm.report.url,"frameBorder":"0","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }